import { useEffect, useRef } from 'react';
import { Loader, LoaderRef } from '@servicetitan/web-components';
import softPhoneModule from '@modules/SoftPhoneModule';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import environment from '@lib/environment';

/**
 * SoftPhoneLoader component is responsible for loading the soft phone MFE and initializing the web phone service with the event bus
 * The event bus is used to communicate between the soft phone MFE and the contact center frontend.
 */
const SoftPhoneLoader = () => {
  const { user } = useAuth();
  const softPhoneLoaderRef = useRef<LoaderRef>(null);

  const hasWebPhoneToken = !!user?.webPhoneToken;

  useEffect(() => {
    const eventBus = softPhoneLoaderRef.current;
    if (hasWebPhoneToken) {
      // initialize the soft phone with the event bus once the webPhoneToken is available
      softPhoneModule.initializeWebPhoneService(eventBus ?? undefined);
    }
  }, [hasWebPhoneToken]);

  return (
    <div className='d-n'>
      <Loader
        ref={softPhoneLoaderRef}
        src={environment.SOFTPHONE_MFE_URL}
        data={{
          jwt: user?.webPhoneToken ?? '',
          sipUri: `wss://${environment.SOFTPHONE_SIP_URL}`,
        }}
      />
    </div>
  );
};

export default SoftPhoneLoader;
